import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { JwtService } from './jwt.service';
import { BrowserService } from 'src/_lib/service/browser.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private jwt: JwtService,
    private browser: BrowserService
  ) { }

  canActivate(): boolean | UrlTree {
    if (!this.browser.isBrowser) {
      return true;
    }
    const token = this.jwt.getTokenFromLocalStorage();
    if (!token) {
      this.browser.localStorage?.clear();
      return this.router.parseUrl('/customer-login');
    }
    return true;
  }
}